module.exports = __webpack_public_path__ + "static/media/menu.76505737.svg";